import { Injectable } from '@angular/core';
import { createInstance } from 'localforage';
import { AppTheme } from './theme.service';
import { Language } from '../model/common/language';
import { RememberedFacilitySignIns } from '../model/locations/facility-sign-in';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  store: any;
  constructor() {
    this.store = createInstance({
      name: 'crlinc',
    });
  }

  private persist(key: string, value: any) {
    return this.store.setItem(key, value);
  }

  storeTheme(theme: AppTheme | null) {
    return this.persist('appTheme', theme);
  }

  getTheme(): Promise<AppTheme | null> {
    return this.store.getItem('appTheme');
  }

  storeLang(language: Language | null) {
    return this.persist('appLanguage', language);
  }

  getLang(): Promise<Language | null> {
    return this.store.getItem('appLanguage');
  }

  storeFacilitySignIns(
    facilityUid: string,
    signIns: RememberedFacilitySignIns
  ): Promise<RememberedFacilitySignIns> {
    return this.persist(this.facilitySignInKey(facilityUid), signIns);
  }

  getFacilitySignIns(facilityUid: string): Promise<RememberedFacilitySignIns> {
    return this.store
      .getItem(this.facilitySignInKey(facilityUid))
      .then((stored: RememberedFacilitySignIns | null) => stored ?? []);
  }

  private facilitySignInKey(facilityUid: string): string {
    return `facilitySignIn:${facilityUid.toLowerCase()}`;
  }
}
